const localStorageService = (() => {
  const clearStorage = (): void => {
    localStorage.clear();
  };

  const setToken = (oauthBody): void => {
    localStorage.setItem(
      "@UltragazEmpresarial:accessToken",
      oauthBody.access_token
    );
    localStorage.setItem(
      "@UltragazEmpresarial:refreshToken",
      oauthBody.refresh_token
    );
  };

  const getAccessToken = (): string => {
    return localStorage.getItem("@UltragazEmpresarial:accessToken");
  };

  const getRefreshToken = (): string => {
    return localStorage.getItem("@UltragazEmpresarial:refreshToken");
  };

  return {
    clearStorage,
    setToken,
    getAccessToken,
    getRefreshToken,
  };
})();

export default localStorageService;
